function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {//        marginBottom: props => { return theme.spacing(props.spacing) }
  }
}));

const Field = (_ref) => {
  let id = _ref.id,
      name = _ref.name,
      language = _ref.language,
      layout = _ref.layout,
      type = _ref.type,
      hidden = _ref.hidden,
      draggable = _ref.draggable,
      draggableHandle = _ref.draggableHandle,
      toolbar = _ref.toolbar,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "name", "language", "layout", "type", "hidden", "draggable", "draggableHandle", "toolbar", "children"]);

  if (hidden) {
    return children;
  } // clone widget


  let widget;

  if (draggable || toolbar && toolbar.length) {
    widget = React.cloneElement(children, {
      draggable: draggable,
      draggableHandle: draggableHandle,
      toolbar: toolbar
    });
  }

  return React.createElement("div", {
    "data-layout": "field",
    "data-name": name
  }, widget || children);
};

export default Field;